import React from 'react';
import { CheckBadgeIcon } from '@heroicons/react/24/outline';
import { useSuccessionTheme } from './SuccessionThemeProvider';

const BCPWelcome = ({ onStartClick }) => {
  const { theme, isLightTheme, isDarkTheme, company } = useSuccessionTheme();
  
  const handleClick = () => {
    if (typeof onStartClick === 'function') {
      onStartClick();
    }
  };

  return (
    <div className="min-h-screen bg-succession-bg-secondary transition-colors duration-300">
      <div className="max-w-3xl mx-auto pt-16 px-4 sm:px-6 lg:px-8">
        <div className="bg-succession-bg-primary border border-succession-border rounded-lg shadow-succession-lg p-8 transition-colors duration-300">
          <div className="flex items-center justify-center mb-6">
            <CheckBadgeIcon className="h-12 w-12 text-succession-primary transition-colors duration-300" />
          </div>
          
          <h1 className="text-2xl font-bold text-center mb-6 text-succession-text-primary transition-colors duration-300">
            Business Continuity Plan (BCP)
          </h1>
          
          <div className="prose prose-lg mx-auto mb-8">
            <p className="mb-4 text-succession-text-secondary transition-colors duration-300">
              The Business Continuity Plan (BCP) specifies how we will respond to events that significantly 
              disrupt our business and addresses safeguarding our employees and property; ensuring data 
              backup and recovery; restoring mission-critical systems as well as critical regulatory and 
              operational activities; alternative communications with investors, member firms, associated 
              persons, and other regulators; and assuring all of our constituents a prompt response to 
              their needs.
            </p>
            
            <p className="mb-4 text-succession-text-secondary transition-colors duration-300">
              It documents how we plan to continue in business and to maintain as much transparency to 
              our constituents as possible during a disruption.
            </p>
          </div>
          
          <div className="text-center">
            <p className="font-medium mb-4 text-succession-text-primary transition-colors duration-300">
              Ready to get started?
            </p>
            
            <button
              onClick={handleClick}
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-succession-primary hover:opacity-90 transition-all duration-300"
            >
              Start Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BCPWelcome; 